module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "imbee-loader-container",
    style: ({
      backgroundColor: _vm.loaderBackground
    })
  }, [(_vm.loader == 'BeatLoader') ? _c('BeatLoader', {
    attrs: {
      "color": _vm.loaderColor
    }
  }) : _vm._e(), _vm._v(" "), (_vm.loader == 'PropagateLoader') ? _c('PropagateLoader', {
    attrs: {
      "color": _vm.loaderColor
    }
  }) : _vm._e(), _vm._v(" "), (_vm.loader == 'GridLoader') ? _c('GridLoader', {
    attrs: {
      "color": _vm.loaderColor,
      "margin": "10px"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.loader == 'SquareLoader') ? _c('SquareLoader', {
    attrs: {
      "color": _vm.loaderColor
    }
  }) : _vm._e(), _vm._v(" "), (_vm.loader == 'CircleLoader') ? _c('CircleLoader', {
    attrs: {
      "color": _vm.loaderColor
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-224cd782"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LoaderContainer.vue
// module id = 206
// module chunks = 0 1